export default __webpack_public_path__ + "static/media/watermelon.36718a4c.webp";